import React, { useState, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid';

import { useDispatch } from "react-redux";

import { Button, Header, Icon, Modal } from 'semantic-ui-react'

import {
    RESET_VALIDATION_TOKEN,
    UPDATE_BRIEF_RESPONSE_ANSWERS,
    UPDATE_STORED_RESPONSE,
    SG_UPDATE_BRIEF_RESPONSE,
} from "constants/actions";

import {words} from '../AuditV3/translations'

// Theme
import { gray1, gray3, gray5, fontFamily } from 'styled/colors'

// Brand colors used across the app
const brandBlue = '#2d70e2';
const brandBlueHover = '#1b5fc4';

// UI styles
const ui = {
    modal: {
        borderRadius: 16,
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(0,0,0,0.18)'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        padding: '20px 24px 8px 24px',
        borderBottom: 'none',
        fontFamily
    },
    iconCircle: {
        width: 56,
        height: 56,
        borderRadius: 28,
        display: 'grid',
        placeItems: 'center',
        lineHeight: 0,
        background: `linear-gradient(135deg, ${brandBlue} 0%, ${brandBlue}33 100%)`,
        color: '#fff'
    },
    icon: {
        color: '#fff',
        margin: 0,
        lineHeight: 1
    },
    title: {
        fontWeight: 700,
        color: gray1,
        letterSpacing: 0.2
    },
    subtitle: {
        color: gray3,
        marginTop: 4
    },
    content: {
        padding: 24,
        paddingTop: 8,
        lineHeight: 1.6,
        color: gray3,
        fontFamily
    },
    actions: {
        display: 'flex',
        gap: 12,
        padding: '12px 16px 16px 16px',
        background: '#fff',
        borderTop: `1px solid ${gray5}`
    },
    btnPrimary: {
        backgroundColor: brandBlue,
        color: '#fff',
        borderRadius: 10,
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
    },
    btnGhost: {
        backgroundColor: '#fff',
        color: gray1,
        borderRadius: 10,
        border: `1px solid ${gray5}`
    }
}

// const VALIDATION_TOKEN = localStorage.getItem("validation_token");
//         storedResponseFound={storedResponseFound}
// storedResponse={storedResponse}
function AuditExistingDataFound({ 
    setQuestionNo,
    setVisualQuestionNo,
    briefResponseId,
    token,
    resetValidationToken,
    storedResponse,
    storedResponseFound,
    setCurrentQuestionNo,
    setCurrentQuestionDet,
    setQuestionSequenceMap, 
    setShowingStoredResponse,
    language,
    questionSequenceMapRef}) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(true)

    const [timed, setTimed] = useState(true)
    const [defaultMessage, setDefaultMessage] = useState({
        header: "Searching ...",
        text: "Looking for an earlier response, please wait ..."
    })
// c0ab26e7-151b-4acd-b73e-9b6ca86f5e83
    function ResetSurvey() {
        const NewValidationToken = uuidv4()
        localStorage.setItem("validation_token", NewValidationToken)
        resetValidationToken(NewValidationToken)
        dispatch({
            type: SG_UPDATE_BRIEF_RESPONSE,
            payload: {
                id: briefResponseId,
                query: `?token=${token}`,
                validation_token: NewValidationToken,
                reset_stored_data : true, // makes validation_token null
            }
        })
        setOpen(false)
        setShowingStoredResponse(true)
    }

    useEffect(() => {
		const timer1 = setTimeout(() => {
			setTimed(false)
		}, 1000);
		return () => clearTimeout(timer1);
	},[timed])


    function Continue() {
        let NUMS = storedResponse?.current_question
        if (NUMS) {    
            const _checkFdbk = storedResponse?.questionSequenceMap?.[NUMS]?.response?.skipped
            // check if follow up and feedback is skipped
            if (_checkFdbk) {
                NUMS--
            }
            setCurrentQuestionNo(NUMS)
            setCurrentQuestionDet(storedResponse?.questionSequenceMap?.[NUMS])
            if (questionSequenceMapRef) {
                questionSequenceMapRef.current = storedResponse?.questionSequenceMap || {}
            }
            setQuestionSequenceMap(storedResponse?.questionSequenceMap)
            
        }

        dispatch({
            type: UPDATE_BRIEF_RESPONSE_ANSWERS,
            payload: storedResponse, 
            
        });
        setShowingStoredResponse(true)
        setQuestionNo(NUMS)
        setOpen(false)
        setVisualQuestionNo(storedResponse?.visual_question || NUMS)
    }

    return (
        <Modal
            open={open}
            size='small'
            style={ui.modal}
            closeOnEscape={false}
            closeOnDimmerClick={false}
        >
            <Header as='h2' style={ui.header}>
                <div style={ui.iconCircle}>
                    {timed ? 
                        <Icon loading inverted name='spinner' style={ui.icon} />
                        :
                        <Icon inverted name='archive' style={ui.icon} />
                    }
                </div>
                <Header.Content style={ui.title}>
                    {language? words['Searching'][language] :defaultMessage?.header}
                    <Header.Subheader style={ui.subtitle}>
                        {language? words['Searching2'][language] : defaultMessage?.text}
                    </Header.Subheader>
                </Header.Content>
            </Header>
            <Modal.Content style={ui.content}>
                {/* Keeping for spacing and potential future details */}
            </Modal.Content>
            <Modal.Actions style={ui.actions}>
                <Button
                    basic
                    onClick={ResetSurvey}
                    id={'btn-existingdata-reset'}
                    size="medium"
                    style={ui.btnGhost}
                >
                    <Icon name='refresh' /> {language? words['Restart'][language]:'Restart survey'}
                </Button>

                <Button
                    disabled={timed}
                    onClick={Continue}
                    size="medium"
                    id={'btn-existingdata-resume'}
                    style={ui.btnPrimary}
                >
                    <Icon name='checkmark' /> {language? words['Load'][language]:'Load saved survey'}
                </Button>

            </Modal.Actions>
        </Modal>
    )
}

export default AuditExistingDataFound